import { combineReducers } from "redux";
import { takeLatest } from "redux-saga/effects";
import { createSelector } from "reselect";
import { mapPermissions } from "store/state/auth";
import {
  defaultReturn
  , makePayload
  , generateDefaultActions
  , requestSaga
  , makeIsLoadingReducer
} from "shared-utility/store/utils/helpers";

// ACTIONS
export const PAID_LOAN_GET_DEAL = generateDefaultActions("PAID_LOAN_GET_DEAL");
export const paidLoanGetDeal = payload => makePayload(PAID_LOAN_GET_DEAL.value, payload);
function* paidLoanGetDealSaga(payload) {
  const url = `/getDealName/${payload.dealId}`;
  yield requestSaga(PAID_LOAN_GET_DEAL, url, "GET");
}

export const PAID_LOAN_GET_PAID_LOANS_BY_DEAL = generateDefaultActions("PAID_LOAN_GET_PAID_LOANS_BY_DEAL");
export const paidLoanGetPaidLoansByDeal = payload => makePayload(PAID_LOAN_GET_PAID_LOANS_BY_DEAL.value, payload);
function* paidLoanGetPaidLoansByDealSaga(payload) {
  const url = `/loans/deal/${payload.dealId}/paidOff`;
  yield requestSaga(PAID_LOAN_GET_PAID_LOANS_BY_DEAL, url, "GET");
}

export const PAID_LOAN_GET_TERMINATED_HEDGES_BY_DEAL = generateDefaultActions("PAID_LOAN_GET_TERMINATED_HEDGES_BY_DEAL");
export const paidLoanGetTerminatedHedgesByDeal = payload => makePayload(PAID_LOAN_GET_TERMINATED_HEDGES_BY_DEAL.value, payload);
function* paidLoanGetTerminatedHedgesByDealSaga(payload) {
  const url = `/hedges/deal/${payload.dealId}/terminated`;
  yield requestSaga(PAID_LOAN_GET_TERMINATED_HEDGES_BY_DEAL, url, "GET");
}

// REDUCER

const initialState = {
  deal: {},
  loans: [],
  hedges: []
};

function paidLoanModuleReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case PAID_LOAN_GET_DEAL.success:
      return defaultReturn(state, payload.data, "deal");

    case PAID_LOAN_GET_PAID_LOANS_BY_DEAL.success:
      return defaultReturn(state, payload.data, "loans");

    case PAID_LOAN_GET_TERMINATED_HEDGES_BY_DEAL.success:
      return defaultReturn(state, payload.data, "hedges");

    default:
      return state;
  }
}

export default combineReducers({
  paidLoanModuleReducer,
  paidLoanModulePaidLoanByDealLoading: makeIsLoadingReducer(PAID_LOAN_GET_PAID_LOANS_BY_DEAL)
});

// SAGA

export function* paidLoanModuleSaga() {
  yield takeLatest(PAID_LOAN_GET_DEAL.value, paidLoanGetDealSaga);
  yield takeLatest(PAID_LOAN_GET_PAID_LOANS_BY_DEAL.value, paidLoanGetPaidLoansByDealSaga);
  yield takeLatest(PAID_LOAN_GET_TERMINATED_HEDGES_BY_DEAL.value, paidLoanGetTerminatedHedgesByDealSaga);
}

// SELECTORS

export const mapModulePermissions = createSelector(mapPermissions, auth => ({
  canViewModule: auth && !auth.isGuest
}));
